function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" {...props}><path d="M20.797 14.839l-10.265-.061V9.765v-.063a5.133 5.133 0 1 1 10.266 0v5.137zm-10.007-.318l9.749.057V9.764v-.061a4.875 4.875 0 0 0-9.75 0v4.819z" /><path d="M20.062 14.761l-8.795-.052V9.622a4.403 4.403 0 0 1 4.397-4.397c2.126 0 4.398 1.562 4.398 5.946v3.59zm-8.537-.309l8.279.049v-3.329c0-3.508-1.586-5.688-4.139-5.688a4.143 4.143 0 0 0-4.139 4.139v4.829z" /><path d="M25.234 26.83H6.251V14.593h18.983V26.83zm-18.726-.258h18.467V14.851H6.508v11.721z" /></svg>;
});